import axios, { urlSRelease } from '..';
import { type ConfigObject, type DebugLevel, type Language } from '../../../_configs/types';
import { type CarList } from '../../../_types/Car';
import checkUndefinedNullOrEmpty from '../../../utils/tools/checkUndefinedNullOrEmpty';

export default function getAllFacets(idFirma: ConfigObject['general']['idFirma'], currentLang: Language['value'], useLocationAlias: boolean, signal: AbortController['signal'], debug: DebugLevel) {
    const dataPathString = [];
    const dataPath: any = { firma: idFirma, nfzHersteller: 1, fiza: 1, leas: 1, lang: currentLang?.split('-')?.[0] || 'de', onlyFacetten: 1 };

    for (let i = 0; i < Object.keys(dataPath).length; i++) {
        const key = Object.keys(dataPath)[i];
        const value = dataPath[key];
        if (!checkUndefinedNullOrEmpty(value) && value !== -100 && value !== '-100') dataPathString.push(key + '=' + value);
    }

    // Replace default location alias with location names
    if (useLocationAlias) {
        dataPathString.push('aliasNames=0');
    }

    return axios<CarList>({
        debug,
        title: 'Abrufen der Facetten',
        noLogging: false,
        idFirma,
        method: 'get',
        signal,
        url: `${urlSRelease}/search/glist?${dataPathString.join('&')}`,
    });
}
